import React, { useState, useEffect } from 'react';
import UserMaintenance from './Pages/UserMaintenance'
import './Container.css';

function Container(props) {
  const [user, setUser] = useState(props?.user);

  useEffect(() => {
    setUser(props?.user)
  });

  return (
    <div className="App">
        <div>
            <div className='request-header'>
                <p>User Management</p>
            </div>
            <div className='request-form'>
              {user ? <UserMaintenance user={user} /> : ''}         
            </div>
        </div>
    </div>
  );
}

export default Container;